import React, {useState} from 'react';
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import OrderSummaryComponent from "../../../pages/checkout/orderSummaryComponent";
import PropTypes from "prop-types";
import CheckoutNavigationSteps from "./checkoutNavigationSteps";
import {convertCartToPurchaseData} from "../../../modules/checkoutHelpers";
import {sendSlackMessage} from "../../../models/notifications";

export default function  PaymentComponent() {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const submitPayment = async () => {
        if (!stripe || !elements || submitting) return;
        setSubmitting(true);
        setErrorMessage(null);

        const baseURL = window.location.origin;
        const returnURL = `${baseURL}/status`;
        const response = await stripe.confirmPayment({
            elements,
            confirmParams: { return_url: returnURL },
        });

        if (response.error) {
            setErrorMessage(response.error.message);
            setSubmitting(false);
        } else {
            convertCartToPurchaseData();
        }
    };

    // Keep form onSubmit as keyboard fallback (Enter key inside PaymentElement)
    const handleSubmit = (event) => {
        event.preventDefault();
        submitPayment();
    };

    return (
        <div className="mx-auto max-w-2xl px-4 pb-24 sm:px-6 lg:max-w-7xl lg:px-8">

            <form onSubmit={handleSubmit}>
                <div className="border-t border-gray-200 m-4">
                    <CheckoutNavigationSteps selectedIndex={0}/>
                </div>
                <div className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
                    <div>
                        <div className="border-t border-gray-200 m-4">
                            {/*<h2 className="text-lg font-bold text-gray-900">Submit payment</h2>*/}
                        </div>
                        <PaymentElement options={{
                            layout: 'accordion',
                        }}/>
                        {errorMessage && (
                            <div style={{ marginTop: "12px", padding: "12px 14px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", fontSize: "13px", color: "#dc2626" }}>
                                {errorMessage}
                            </div>
                        )}
                    </div>

                    <div>
                        <OrderSummaryComponent
                            hideToggleFrequency={true}
                            ctaString={submitting ? "Processing…" : "Submit payment"}
                            ctaAction={() => {
                                sendSlackMessage("✅Clicked on the submit button.");
                                submitPayment();
                            }}
                            onToggleFrequency={() => {}}
                        />

                        {/*{errorMessage && <div>{errorMessage}</div>}*/}
                    </div>
                </div>
            </form>

        </div>
    )
};


PaymentComponent.propTypes = {}